import {css} from 'lit';

export default css`
::selection {
  background: var(--brand);
  color: var(--brand-text);
}

  :host {
    position: relative;
    display: inline-block;
  }

  span.wrapper {
    margin-right: 14px;
  }

  span.wrapper::after {
    position: absolute;
    right: 0;
    top: 6px;
    display: inline-block;
    content: '';
    width: 12px;
    height: 12px;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMEM5LjA1MDU4IC0xLjU2NTQ4ZS0wOCAxMC4wOTA5IDAuMjA2OTI2IDExLjA2MTUgMC42MDg5NjRDMTIuMDMyMSAxLjAxMSAxMi45MTQgMS42MDAyOCAxMy42NTY5IDIuMzQzMTVDMTQuMzk5NyAzLjA4NjAxIDE0Ljk4OSAzLjk2NzkzIDE1LjM5MSA0LjkzODUzQzE1Ljc5MzEgNS45MDkxNCAxNiA2Ljk0OTQzIDE2IDhDMTYgOS4wNTA1OCAxNS43OTMxIDEwLjA5MDkgMTUuMzkxIDExLjA2MTVDMTQuOTg5IDEyLjAzMjEgMTQuMzk5NyAxMi45MTQgMTMuNjU2OSAxMy42NTY5QzEyLjkxNCAxNC4zOTk3IDEyLjAzMjEgMTQuOTg5IDExLjA2MTUgMTUuMzkxQzEwLjA5MDkgMTUuNzkzMSA5LjA1MDU4IDE2IDggMTZDNS44NzgyNyAxNiAzLjg0MzQ0IDE1LjE1NzEgMi4zNDMxNSAxMy42NTY5QzAuODQyODU1IDEyLjE1NjYgMCAxMC4xMjE3IDAgOEMwIDUuODc4MjcgMC44NDI4NTUgMy44NDM0NCAyLjM0MzE1IDIuMzQzMTVDMy44NDM0NCAwLjg0Mjg1NSA1Ljg3ODI3IDMuMTYxNjNlLTA4IDggMFYwWk05LjMzMzMzIDEzLjMzMzNWNi42NjY2N0g2LjY2NjY3VjEzLjMzMzNIOS4zMzMzM1pNOS4zMzMzMyA1LjMzMzMzVjIuNjY2NjdINi42NjY2N1Y1LjMzMzMzSDkuMzMzMzNaIiBmaWxsPSIjMjI2OUMzIi8+Cjwvc3ZnPgo=');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .pop__image {
    height: 199px; /* object-fit 1px bottom issue */
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .pop__bg {
    position: absolute;
    inset: -4px;
    background-size: cover;
    filter: blur(4px) brightness(60%) contrast(60%);
    -webkit-filter: blur(4px) brightness(60%) contrast(60%);
  }

  img {
    position: relative;
    width: auto;
    max-width: 100%;
    height: 200px;
    object-fit: contain;
  }

  a {
    position: relative;
    color: var(--system-hyperlink);
    margin: 0;
    padding: 0 14px;
    text-align: right;
    font-size: 14px;
    text-decoration: none;
    list-style: none;
    font-style: normal;
    flex: 0 1 auto;
    -webkit-text-size-adjust: none;
  }

  a:hover {
    background-color: var(--link-bg-hover);
  }

  a::after {
    display: inline-block;
    content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDggMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy44NzY2NCA4LjE4MTA0TDAuNzMyMzM2IDAuNjMzMjg0QzAuNTY0MTU1IDAuNDU1NTcyIDAuMjk0MzggMC40NTU1NzIgMC4xMjYxMzYgMC42MzMyODRDLTAuMDQyMDQ1MiAwLjgxMDk5NyAtMC4wNDIwNDUyIDEuMDk2MDEgMC4xMjYxMzYgMS4yNzM3Mkw2Ljk2NTc2IDguNDk5NThMMC4xMjYxMzYgMTUuNzI1NEMtMC4wNDIwNDUyIDE1LjkwMzIgLTAuMDQyMDQ1MiAxNi4xODgyIDAuMTI2MTM2IDE2LjM2NTlDMC4yMDg2NTUgMTYuNDUzMSAwLjMxOTczOSAxNi41IDAuNDI3NjQ5IDE2LjVDMC41MzU1OTEgMTYuNSAwLjY0NjY3NCAxNi40NTY0IDAuNzI5MTYyIDE2LjM2NTlMNy44NzM0NCA4LjgxODEyQzguMDQxNjUgOC42NDM3NiA4LjA0MTY1IDguMzU1NCA3Ljg3NjY0IDguMTgxMDRaIiBmaWxsPSIjNzE3MTcxIi8+Cjwvc3ZnPgo=');
    width: 8px;
    height: 17px;
    position: absolute;
    right: 0;
    bottom: 4px;
  }

  .link__wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .pop {
    position: fixed;
    box-sizing: border-box;
    z-index: 19998;
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 340px;
    min-height: 380px;
    background: var(--surface-overlay);
    border-radius: 4px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  }

  .pop__title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .pop__name {
    line-height: 19px;
    font-size: 15px;
  }

  .pop__beruf {
    line-height: 26px;
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: 16px;
  }

  #mobileDialog {
    color: var(--text-highVisibility);
    background: var(--surface-overlay);
    padding: 2rem;
    border-radius: 4px;
    border: 0;
    width: 80%;
    max-width: 340px;
  }

  #mobileDialog::backdrop {
    /* TODO: Use a CSS property once the dialog backdrop pseudo-element inherits them. */
    background: rgb(0 0 0 / 85%);
  }

  .close__container {
    position: relative;
    height: 24px;
    width: 24px;
    margin-left: auto;
    border: 0;
    background-color: transparent;
  }

  .close__leftright,
  .close__rightleft {
    height: 3px;
    width: 24px;
    left: 0;
    position: absolute;
    display: inline-block;
    background-color: var(--icon-highVisibility);
    border-radius: 2px;
  }

  .close__leftright {
    transform: rotate(45deg);
  }

  .close__rightleft {
    transform: rotate(-45deg);
  }

  .close__container:focus,
  .close__container:focus-visible {
    outline: none;
  }
`;
